/* UnionX 13/08/2026 — pone el src de las imagenes del mega-menu SOLO en escritorio.
   En celular esas imagenes no se muestran nunca (ahi el menu es el cajon lateral) y se
   estaban descargando igual: 23 imagenes, 629 KB por visita.

   🪤 No basta con correr una vez: Horizon vuelve a renderizar el mega-menu por la
   Section Rendering API DESPUES de DOMContentLoaded (lo dice su propio comentario en
   snippets/mega-menu-list.liquid). La primera version dejo 23 de 46 imagenes sin src
   en escritorio. Por eso hay un MutationObserver. */
(function () {
  var CONSULTA = '(min-width: 750px)';
  function esEscritorio() { return !window.matchMedia || window.matchMedia(CONSULTA).matches; }
  function cargar(raiz) {
    if (!esEscritorio()) return;
    var faltantes = (raiz || document).querySelectorAll('img[data-lhx-menuimg]');
    for (var i = 0; i < faltantes.length; i++) {
      var el = faltantes[i];
      el.src = el.getAttribute('data-lhx-menuimg');
      el.removeAttribute('data-lhx-menuimg');
    }
  }
  function arrancar() {
    cargar();
    if (window.MutationObserver) {
      new MutationObserver(function (cambios) {
        for (var i = 0; i < cambios.length; i++) {
          if (cambios[i].addedNodes && cambios[i].addedNodes.length) { cargar(); return; }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
  window.addEventListener('resize', function () { cargar(); }, { passive: true });
})();
